<template>
  <b-modal
    id="myid2"
    ref="modal"
    title="챕터 생성"
    @show="resetModal"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        label="챕터유형"
        label-for="chapter_pick"
        invalid-feedback="챕터타입은 비어있을수 없습니다."
        :state="cflagState"
      >
        <b-form-radio-group
          id="chapter_pick"
          v-model="cflag"
          :options="chaptertype_options"
          name="radio-options1"
          :state="cflagState"
          required
        >
        </b-form-radio-group>
      </b-form-group>

      <b-form-group
        label="챕터명"
        label-for="title"
        invalid-feedback="챕터명은 비어있을수 없습니다."
        :state="titleState"
      >
        <b-form-input
          id="title"
          v-model="title"
          :state="titleState"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="공통코드" label-for="code">
        <b-form-input id="code" v-model="cmm_code"></b-form-input>
      </b-form-group>
    </form>
    <b-alert show variant="danger">
      <ul>
        <li>
          <b-badge variant="danger">공통코드</b-badge>를 참조하여 저장즉시
          문항의 챕터, 유닛 정보가 업데이트
        </li>
        <li>
          하위유닛이 없는 챕터에만
          <b-badge variant="danger">공통코드</b-badge>를 적용하여야 함
        </li>
      </ul>
    </b-alert>
  </b-modal>
</template>

<script>
import * as _ from "lodash";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: ["formChapter"],
  data() {
    return {
      title: null,

      titleState: null,
      codeState: null,
      loading: false,
      cmm_code: null,
      id: null,
      cflag: null,
      cflagState: null,
      uorder: null,
    };
  },

  computed: {
    ...mapState("chapterStore", ["book_id", "chaptertype_options"]),
  },

  methods: {
    ...mapActions("chapterStore", [
      "postChapter",
      "putChapter",
      "getChapterList",
    ]),
    resetModal() {
      this.title = this.formChapter.ctitle;
      this.cmm_code = this.formChapter.cmm_code;
      this.id = this.formChapter.id;
      this.cflag = this.formChapter.cflag;

      this.loading = false;
      this.titleState = null;
      this.codeState = null;
      this.cflagState = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      // this.codeState = _.isEmpty(this.code) ? false : true;
      this.titleState = _.isEmpty(this.title) ? false : true;
      this.cflagState = _.isEmpty(this.cflag) ? false : true;
      return valid;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }

      this.loading = true;
      if (this.id != undefined) {
        let resp = await this.putChapter({
          ctitle: this.title,
          id: this.id,
          cmm_code: this.cmm_code,
          cflag: this.cflag,
        });
      } else {
        let resp = await this.postChapter({
          ctitle: this.title,
          cmm_code: this.cmm_code,
          cflag: this.cflag,
        });
      }
      this.loading = false;
      let $this = this;

      this.$nextTick(() => {
        this.$bvModal.hide("myid2");
        this.loading = true;

        let query = {
          flag: 0,
          subflag: null,
          book_id: $this.book_id,
        };
        this.getChapterList(query);
      });
    },
  },
};
</script>


<style lang="scss" scoped>
</style>